import { NoResultsState } from '../../models';

export function getInitialNoResultsState(): NoResultsState {
  return {
    fallbackFiltersResults: {}
  };
}
